import { defineStore } from "pinia";
import { ref } from "vue";

export const useDecisionGridStore = defineStore('decisionGrid', () => {
    const hidePrice = ref(false);
    const hideNds = ref(false);

    function setHidePrice(value) {
        hidePrice.value = value;
    }

    function setHideNds(value) {
        hideNds.value = value;
    }

    return {
        hidePrice,
        hideNds,
        setHidePrice,
        setHideNds,
    }
});
